import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/admin/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Clean hash and go to admin
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        navigate("/admin/login", { replace: true, state: { error: e?.response?.data?.detail || "Sign-in failed." } });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-sm text-[#6B7280]">Signing you in…</div>
    </div>
  );
}
